<template>
  <modal :active="active" @close="handleCloseModal">
    <div v-if="actionType == 'createModal'" slot="title">
      Create New Project Valuation
    </div>
    <div v-else slot="title">Update Project Valuation</div>
    <div class="col-12">
      <label>Project</label>
      <select class="custom-select" v-model="project_id">
        <option
          v-for="project in projects"
          :key="project.code"
          :value="project.id"
        >
          {{ project.code }} {{ project.name }}
        </option>
      </select>
    </div>
    <div class="col-12" style="margin-top: 10px; display: flex">
      <div style="padding-left: 0" class="col-6">
        <label>Year</label>
        <select class="custom-select" v-model="year">
          <option v-for="year in years" :key="year" :value="year">
            {{ year }}
          </option>
        </select>
      </div>
      <div style="padding-right: 0" class="col-6">
        <label>Quarter</label>
        <select class="custom-select" v-model="quarter_number">
          <option v-for="quarter in quarters" :key="quarter" :value="quarter">
            {{ quarter }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-12" style="margin-top: 10px; display: flex">
      <div style="padding-left: 0" class="col-6">
        <label>Value</label>
        <input
          class="form-control"
          min="0"
          type="number"
          required
          v-model="value"
        />
      </div>
      <div style="padding-right: 0" class="col-6">
        <label>Exchange Rate</label>
        <input
          class="form-control"
          min="0"
          type="number"
          required
          v-model="exchange_rate"
        />
      </div>
    </div>
    <div class="col-12" style="margin-top: 15px">
      <label id="date">Date</label>
      <input class="form-control" type="date" id="date" v-model="date" />
    </div>
    <div slot="footer">
      <button type="button" class="btn btn-info" @click="handleSave()">
        Save
      </button>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import ProjectValuationStorer from "../../../../storers/StoreProjectValuation";
import ProjectsFilter from "../../../../filters/ProjectsFilter";

import { mapState } from "vuex";
export default {
  data() {
    return {
      project_id: null,
      year: new Date().getFullYear(),
      quarter_number: null,
      value: null,
      exchange_rate: null,
      date: null,
      years: [],
      quarters: ["Q1", "Q2", "Q3", "Q4"],
    };
  },
  props: {
    active: Boolean,
    actionType: String,
    activeProjectValuation: Object,
  },
  components: { Spinner, Modal },
  created: function () {
    var projectsFilter = ProjectsFilter();
    this.$store.dispatch("searchProjects", {
      filter: projectsFilter,
      resultMode: "default",
    });
  },
  mounted() {
    this.generateYearList();
  },
  computed: {
    ...mapState({
      projects: (state) => state.projectStore.projectSearch.projects,
    }),
  },
  methods: {
    init() {
      this.project_id = null;
      this.year = new Date().getFullYear();
      this.quarter_number = null;
      this.value = null;
      this.exchange_rate = null;
      this.date = null;
    },
    fillForm() {
      this.project_id = this.activeProjectValuation.project_id;
      this.year = this.activeProjectValuation.year;
      this.quarter_number = this.activeProjectValuation.quarter_number;
      this.value = this.activeProjectValuation.value;
      this.exchange_rate = this.activeProjectValuation.exchange_rate;
      this.date = this.activeProjectValuation.date;
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
    handleSave() {
      var projectValuation = ProjectValuationStorer();
      if (this.actionType == "updateModal") {
        projectValuation.id = this.activeAsset.id;
      }
      projectValuation.project_id = this.project_id;
      projectValuation.year = this.year;
      projectValuation.quarter_number = this.quarter_number;
      projectValuation.value = this.value;
      projectValuation.exchange_rate = this.exchange_rate;
      projectValuation.date = this.date;
      this.$emit("saveRequest", projectValuation);
    },
    generateYearList() {
      const currentYear = new Date().getFullYear();
      for (let year = currentYear; year >= 1900; year--) {
        this.years.push(year);
      }
    },
  },
  watch: {
    actionType() {
      if (this.actionType == "updateModal") {
        this.fillForm();
      }
    },
    active() {
      this.init();
    },
  },
};
</script> 
 <style>
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/valuationModal.vue